module.exports = __webpack_public_path__ + "img/CF_success.3a1765c9.svg";